import React from 'react'

const Paper = ({ children, className }) => {
  return (
    <div className={`bg-white p-6 rounded-xl ${className}`}>{children}</div>
  )
}

export default Paper